import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.625 21q-2.35 0-3.987-1.637Q3 17.724 3 15.375A5.59 5.59 0 0 1 4.65 11.4l6.75-6.75A5.59 5.59 0 0 1 15.375 3q2.35 0 3.988 1.638Q21 6.274 21 8.625a5.59 5.59 0 0 1-1.65 3.975l-6.75 6.75A5.59 5.59 0 0 1 8.625 21m6.65-7.15 2.675-2.65A3.68 3.68 0 0 0 19 8.625q0-1.5-1.063-2.563A3.5 3.5 0 0 0 15.376 5 3.68 3.68 0 0 0 12.8 6.05l-2.65 2.675zM8.625 19a3.68 3.68 0 0 0 2.575-1.05l2.65-2.675-5.125-5.125L6.05 12.8A3.68 3.68 0 0 0 5 15.375q0 1.5 1.063 2.563A3.5 3.5 0 0 0 8.624 19Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }